import { Link, useParams } from "react-router-dom";
import { PublicHeader } from "../components/PublicHeader";
import { StatusPanel } from "../components/StatusPanel";

const titles: Record<string, string> = {
  privacy: "Privacy Notice",
  terms: "Platform Terms",
  contractor: "Contractor Terms",
  guardian: "Guardian Agreement",
  deletion: "Data Request",
};

const summaries: Record<string, string[]> = {
  privacy: [
    "We collect the details you send in your application, your verified Discord identity, work records, evidence, reviews, and payout records.",
    "We use this data to review applications, match tasks, verify work, prevent fraud, operate training, and pay approved earnings.",
    "Payout destinations are encrypted. Public proof is never published without separate permission and redaction.",
    "You can ask for a copy or request deletion. Some financial and audit records may need to be kept by law.",
  ],
  terms: [
    "Applying, training, and membership do not guarantee tasks, work, earnings, rank, or access to any person.",
    "Members must protect private lead information, follow each approved SOP, respect third-party platform rules, and submit only work they completed.",
    "Spam, harassment, fabricated evidence, deceptive recommendations, recruitment-only earning schemes, and misuse of client data are prohibited.",
    "Access can be suspended for false evidence, unsafe conduct, trust violations, chargebacks, or breaking platform rules.",
  ],
  contractor: [
    "Where legally permitted, members perform accepted tasks as independent participants rather than employees. Local law may impose rights or obligations that these terms cannot waive.",
    "Each offer shows its USD reward, deadline, evidence requirements, and settlement conditions before acceptance.",
    "Approved available earnings can be requested from $50 through Wise, PayPal, or USDT on Tron. Payout destinations and eligibility are manually verified.",
    "Earnings may remain pending or be reversed after rejected work, false evidence, refund, dispute, duplicate payment, or fraud review.",
  ],
  guardian: [
    "People aged 16-17 may apply and use training. Real paid task access remains controlled by country, hours, contract, safety, and identity rules.",
    "A guardian must approve each payout request before an under-18 member’s available balance can be paid.",
    "Guardian approval alone does not make a country or task eligible. Minor paid work remains disabled until a reviewed country rule is enabled.",
  ],
  deletion: [
    "You may request a copy of your data or ask us to delete it.",
    "We verify requests before acting so another person cannot access or delete your information.",
  ],
};

export function LegalPage() {
  const { document = "privacy" } = useParams();
  const title = titles[document] ?? "Legal Document";
  return (
    <div className="public-page">
      <PublicHeader />
      <main id="main-content" className="legal-shell">
        <span className="eyebrow">LEGAL / VERSION 1.0</span>
        <h1>{title}</h1>
        <StatusPanel title="Professional review required" message="This plain-language pilot draft must be approved before real payouts or minor work are activated." />
        {(summaries[document] ?? summaries.privacy).map((paragraph) => <p key={paragraph}>{paragraph}</p>)}
        <div className="hero-actions">
          <Link className="btn" to="/data-request/export">GET MY DATA</Link>
          <Link className="btn" to="/data-request/deletion">DELETE MY DATA</Link>
        </div>
        <Link className="btn" to="/">BACK HOME</Link>
      </main>
    </div>
  );
}
